export const COMPANY_STATUS = {
  NEW_PROSPECT: 1,
  QUALIFIED_PROSPECT: 2,
  NOT_QUALIFIED_PROSPECT: 3,
  ACTIVE_ACCOUNT: 4,
  INACTIVE_ACCOUNT: 5,
  ARCHIVED: 6,
  DNC: 10,
  PRIVATE: 11
};

export const JOB_REQUEST_STATUS = {
  IN_PROGRESS: 1,
  NEW_REQUEST: 2,
  NA: 3,
  APPROVED: 4,
  CANDIDATE_PLACED: 5,
  JOB_CANCELED: 6,
  ABANDONED: 7
};

export const STATUS_GROUPS = {
  IN_PROCESS :1,
  INACTIVE: 2,
  STANDBY: 3,
  QUALIFIED: 4,
  NO_LONGER_PLACEABLE: 5
};

export const CONTACT_STATUS_GROUPS = {
  IN_PROCESS :1,
  INACTIVE: 2,
  STANDBY: 3
};

export const CONTACT_ROLES = {
  BILLING: 1,
  EXECUTIVE: 2,
  HR: 3,
  KEY: 4,
  MAIN: 5,
  MANAGER: 6,
  OWNER: 7,
  REPORTING: 8,
  SUPERVISOR: 9,
  TECHNOLOGY: 10,
  TRAINING: 11,
  SOCIAL_MEDIA: 12,
  NEWSLETTER: 13,
  MARKETING: 14,
  EDITOR: 15
};

export const APPLICANT_STATUS = {
  NEW_APPLICANT: 1,
  PENDING_PRELIMINARY_INTERVIEW: 2,
  PENDING_APPLICATION: 3,
  PENDING_ASSESSMENTS: 4,
  PENDING_APPLICATION_INTERVIEW: 5,
  PENDING_INFORMATION_UPDATE: 6,
  UNRESPONSIVE: 7,
  NOT_QUALIFIED: 8,
  NOT_INTERESTED: 9,
  IN_WAITING: 10,
  QUALIFIED_CANDIDATE: 11,
  READY_TO_PLACE: 12,
  PENDING_REFERENCE_CHECKS: 13,
  ARCHIVED: 14,
  DNC: 15,
  UNAVAILABLE: 16,
  PENDING_REVIEW: 17,
  QUALIFIED_IN_WAITING: 18,
  QUALIFIED_CANDIDATE_IN_QUEUE: 19,
  ACTIVE: 20,
  PLACED: 21,
  UNRESPONSIVE_BH: 22,
  UNAVAILABLE_BH: 23,
  FULLY_RETIRED: 24,
  DIRECT_HIRE: 25,
  NOT_QUALIFIED_BH: 26,
  NOT_INTERESTED_BH: 27,
  PENDING_TECH_EVALUATION: 28,
  DECEASED: 29,
  NO_LONGER_PLACEABLE: 30,
  WAITING_FOR_MATCH: 31
};

export const EMPLOYEE_ROLES = {
  APPLICANT: 1,
  EMPLOYEE: 2,
  CLIENT: 3,
  ADMIN: 4,
  QUALIFYING_SPECIALIST: 5,
  REFERENCE_SPECIALIST: 6,
  PLACEMENT_SPECIALIST: 7,
  OWNER: 8,
  SALES: 9,
  RELATIONSHIP_MANAGER: 10,
  IT_MANAGER: 11,
  ACCOUNTING: 12,
  CLIENT_ADVISER: 13,
  SUPPORT_ASSISTANT: 14
};

export const employeeTypes = ['1099', 'W2', '1099 LLC', 'K-1'];



// WEBPACK FOOTER //
// ./shared/common/enums.js